import React from "react";

const DetailsModal = ({ selectedItem, onClose }) => {
  if (!selectedItem) return null;

  // 🧠 Determine data source (winner or direct inspection)
  const owner =
    selectedItem.shop_owner || selectedItem; // fallback for both structures
  const latestForm = owner?.forms?.[owner.forms.length - 1];

  // Parse form details (string → JSON)
  const parsedForm =
    typeof latestForm?.form_details === "string"
      ? JSON.parse(latestForm.form_details)
      : latestForm?.form_details || {};

  const inspection = parsedForm?.inspection || {};
  const photos = parsedForm?.photos || [];

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-3xl rounded-xl shadow-xl overflow-y-auto max-h-[90vh]">
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-xl font-bold text-gray-800">Details</h2>
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-red-600 text-2xl leading-none"
          >
            &times;
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {/* 🏪 Shop Owner Info */}
          <section>
            <h3 className="text-lg font-semibold text-indigo-700 mb-2">
              🏪 Shop Owner Info
            </h3>
            <div className="flex gap-4 items-center mb-4">
              {owner?.photo_url && (
                <img
                  src={owner.photo_url}
                  alt={owner.owner_name}
                  className="w-24 h-24 object-cover rounded-lg border shadow-sm"
                />
              )}
              <div className="text-sm text-gray-700">
                <p>
                  <span className="font-medium">Owner Name:</span>{" "}
                  {owner?.owner_name || "—"}
                </p>
                <p>
                  <span className="font-medium">Shop Name:</span>{" "}
                  {owner?.shop_name || parsedForm?.shopName || "—"}
                </p>
                <p>
                  <span className="font-medium">Phone:</span>{" "}
                  {owner?.phone_number || "—"}
                </p>
                <p>
                  <span className="font-medium">Shop ID:</span>{" "}
                  {owner?.shop_id || parsedForm?.shopId || "—"}
                </p>
              </div>
            </div>

            {/* 🏆 Winner Info (if available) */}
            {selectedItem.type && (
              <div className="grid grid-cols-2 gap-3 text-sm text-gray-700">
                <p>
                  <span className="font-medium">Winner Type:</span>{" "}
                  {selectedItem.type}
                </p>
                <p>
                  <span className="font-medium">Awarded On:</span>{" "}
                  {selectedItem.awarded_at
                    ? new Date(selectedItem.awarded_at).toLocaleDateString("en-IN")
                    : "—"}
                </p>
                <p>
                  <span className="font-medium">Winner Details:</span>{" "}
                  {selectedItem.winner_details || "—"}
                </p>
              </div>
            )}
          </section>

          {/* 🧾 Inspection Info */}
          <section>
            <h3 className="text-lg font-semibold text-indigo-700 mb-2">
              🧾 Inspection Details
            </h3>
            <div className="grid grid-cols-2 gap-3 text-sm text-gray-700">
              <p>
                <span className="font-medium">Use of Plastic:</span>{" "}
                {inspection?.useOfPlastic || "N/A"}
              </p>
              <p>
                <span className="font-medium">Biodegradable Materials:</span>{" "}
                {inspection?.biodegradableMaterialsUsed || "N/A"}
              </p>
              <p>
                <span className="font-medium">Dustbins Available:</span>{" "}
                {inspection?.dustbinsAvailable || "N/A"}
              </p>
              <p>
                <span className="font-medium">Waste Disposed Properly:</span>{" "}
                {inspection?.wasteDisposedProperly || "N/A"}
              </p>
              <p>
                <span className="font-medium">Cleanliness Rating:</span>{" "}
                {inspection?.cleanlinessRating || "N/A"}
              </p>
              <p>
                <span className="font-medium">Waste on Ground:</span>{" "}
                {inspection?.wasteOnGround || "N/A"}
              </p>
              <p>
                <span className="font-medium">Food Business:</span>{" "}
                {inspection?.isfoodBusiness || "N/A"}
              </p>
              <p>
                <span className="font-medium">Remarks:</span>{" "}
                {parsedForm?.remarks || "—"}
              </p>
              <p>
                <span className="font-medium">Score:</span>{" "}
                {latestForm?.score ?? "—"}
              </p>
            </div>
          </section>

          {/* 📸 Photos */}
          {photos?.length > 0 && (
            <section>
              <h3 className="text-lg font-semibold text-indigo-700 mb-2">
                📸 Inspection Photos
              </h3>
              <div className="flex flex-wrap gap-3">
                {photos.map((photo, index) => (
                  <img
                    key={index}
                    src={`https://wastystorage.s3.us-east-1.amazonaws.com/${photo}`}
                    alt={`Inspection ${index + 1}`}
                    className="w-32 h-32 object-cover rounded-lg border shadow-sm hover:scale-105 transition-transform"
                  />
                ))}
              </div>
            </section>
          )}
        </div>
      </div>
    </div>
  );
};

export default DetailsModal;
